import { BackButton, PageContainer } from "@client/components/ui";
import { Button } from "@client/components/ui/button";
import { Card, CardContent } from "@client/components/ui/card";
import { createFileRoute, Link } from "@tanstack/react-router";
import {
	CreditCard,
	FileText,
	Key,
	Receipt,
	UserCheck,
	Users,
} from "lucide-react";

export const Route = createFileRoute("/(protected)/settings/")({
	component: SettingsIndexPage,
});

function SettingsIndexPage() {
	const settingsPages = [
		{
			title: "Tax Info",
			description: "Manage tax information for invoices and billing",
			icon: FileText,
			href: "/settings/tax",
		},
		{
			title: "Account",
			description: "Profile, security, and account preferences",
			icon: UserCheck,
			href: "/settings/account",
		},
		{
			title: "Invoices",
			description: "View and download your payment invoices",
			icon: Receipt,
			href: "/settings/invoices",
		},
		{
			title: "Billing",
			description: "Manage your billing, credits, and subscriptions",
			icon: CreditCard,
			href: "/settings/billing",
		},
		{
			title: "API Keys",
			description: "Create and manage your API keys",
			icon: Key,
			href: "/settings/api-keys",
		},
		{
			title: "Referrals",
			description: "View referral stats and customize your code",
			icon: Users,
			href: "/settings/referrals",
		},
	];

	return (
		<PageContainer maxWidth="narrow">
			<BackButton to="/dashboard" label="Back to Dashboard" />

			{/* Header */}
			<div className="mb-8">
				<h1 className="font-semibold text-3xl tracking-tight">Settings</h1>
				<p className="mt-1 text-muted-foreground">
					System configuration and account settings
				</p>
			</div>

			<div className="space-y-3">
				{settingsPages.map((page) => {
					const Icon = page.icon;
					return (
						<Card
							key={page.href}
							className="transition-all hover:border-primary/40"
						>
							<CardContent className="flex items-center justify-between p-4">
								<div className="flex items-center gap-4">
									<div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10">
										<Icon className="h-5 w-5 text-primary" />
									</div>
									<div>
										<h3 className="font-medium">{page.title}</h3>
										<p className="text-muted-foreground text-sm">
											{page.description}
										</p>
									</div>
								</div>
								<Button asChild variant="outline" size="sm">
									<Link to={page.href}>Open</Link>
								</Button>
							</CardContent>
						</Card>
					);
				})}
			</div>
		</PageContainer>
	);
}
